import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../../constants/index";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import {
  GetServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

function ObjectTypeList() {
  const navigate = useNavigate();
  const [objTypeDetails, setObjTypeDetails] = useState([]);  
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchObject();
  }, [searchTerm]);

  const columns = {
    Code: { text: "Code", align: "text-start", visible: true },
    DisplayName: { text: "Display Name", align: "text-start", visible: true },
    Name: { text: "Name", align: "text-start", visible: true },
    Description: { text: "Description", align: "text-start", visible: true },
    ObjectTypeIdentifier: { text: "Object Type Identifier" , align: "text-start", visible: true},
    IsAdd: { text: "Add Log" , align:"center", visible: true},
    IsEdit: { text: "Edit Log" , align:"center", visible: true},
    IsDelete: { text: "Delete Log" , align:"center", visible: true},
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Object Type"))
  }, [])

const fetchObject = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}rujul/object-type`);
      let apidata = response?.data?.data;
  
      // Check if apidata is an array before mapping
      if (Array.isArray(apidata)) {
        apidata = apidata.map(item => ({
          ...item,
          IsAdd: item.IsAdd === 1 ? "Yes" : "No",
          IsEdit: item.IsEdit === 1 ? "Yes" : "No",
          IsDelete: item.IsDelete === 1 ? "Yes" : "No",
        }));
      }
  
      setObjTypeDetails(apidata);
    } catch (error) {
      console.error("Error fetching job:", error);
    }
  };
  
  
  const handleEdit = (id) => {
    console.log('id',id);
    
    navigate(`/rujul/admin/object-type/edit/${id.ObjectType}`);
  };

  const handleObjectAdd = () =>{
    navigate("/rujul/admin/object-type/add");
  }

  return (
    <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row">
              <Dynamic_PR_table
                data={objTypeDetails}
                columns={columns}
                itemsPerPage={8}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showIcon1={true}
                isSorting={true}
                handleIcon1={handleEdit}
                isActionRequired={true}
                isAddNewBtnRequired={true}
                handleAddNew={handleObjectAdd}
                add
                more
                function
                icons={{
                  Icon1: <i className="bi bi-pencil-square icons"></i>,
                  Icon1Text:'Edit',
                }}
              /> 
            </div>
          </div>
        </div>

    </>
  );
}

export default ObjectTypeList;
